import React from 'react';
import PropTypes from 'prop-types';
import Header from './the-rules-of-investing-components/header';
import Main from './the-rules-of-investing-components/main';

export default function TheRulesOfInvesting(props) {
  const {
    id, slug, description, numberOfWires,
  } = props.series;
  const {
    appleRating, latestWire, wireBg, breadcrumb,
  } = props;

  return (
    <div>
      <Header type="series" seriesId={id} description={description} wireBg={wireBg} latestWire={latestWire} numberOfWires={numberOfWires} appleRating={appleRating} breadcrumb={breadcrumb} />
      <Main seriesSlug={slug} numberOfWires={numberOfWires} />
    </div>
  );
}

TheRulesOfInvesting.propTypes = {
  series: PropTypes.shape({
    id: PropTypes.number.isRequired,
    slug: PropTypes.string.isRequired,
    description: PropTypes.string,
    numberOfWires: PropTypes.number.isRequired,
  }).isRequired,
  appleRating: PropTypes.number.isRequired,
  latestWire: PropTypes.shape.isRequired,
  wireBg: PropTypes.string.isRequired,
  /* eslint-disable-next-line react/require-default-props */
  breadcrumb: PropTypes.string,
};
